import React, {PureComponent, ReactNode} from "react"

import id from "@irati/utils/id"
import Expander from "@irati/ui/src/Expander"

import {ExpanderWrapper} from "./styled"

interface Props {
  className?: string
  PrimaryElement: () => ReactNode
  SecondaryElement: ReactNode
  id?: string
}

export default class ExpanderItem extends PureComponent<Props> {
  static defaultProps = {
    className: null,
    id: null
  }

  render() {
    const {className, PrimaryElement, SecondaryElement} = this.props
    const idNamespace = id("expander-item", this.props)
    return (
      <ExpanderWrapper className={className} id={idNamespace}>
        <Expander fullWidth Header={PrimaryElement}>
          {SecondaryElement}
        </Expander>
      </ExpanderWrapper>
    )
  }
}
